import React from "react";
import useChatUrl from "../../hooks/useChatUrl";
import styles from "./FooterChat.module.sass";
import { withRouter } from "react-router";

function FooterChat(props) {
  const { callChat } = useChatUrl();

  return (
    <>
      {props.product && (
        <div
          className={styles.footerContent}
          data-gacategory="AutoCompra-Consórcio"
          data-gatype="AutoCompra-Consórcio-Chat-Pg.Identificação"
          data-gafunc="AutoCompra-Consórcio-Chat-Identificação-Fale com um Especialista"
        >
          <label onClick={callChat} className={styles.link} role="link">
            <i className="icon icon-conversa" />
            {props.text}
          </label>
          <span className={styles.subtext}>{props.subtext}</span>
        </div>
      )}
    </>
  );
}

export default withRouter(FooterChat);
